import React from "react";
import { Helmet } from "react-helmet-async";
import { useIntl } from "react-intl";

import { ConfigurationStore } from "stores";

interface IHeader {}

const Header: React.FC<IHeader> = (): JSX.Element | null => {
  const configuration = React.useContext(ConfigurationStore);
  const { formatMessage: t } = useIntl();
  const href = window.location.href;
  const headline = t({
    id: "pages.Fahrzeuge.title",
    defaultMessage: "Übersicht der verfügbaren Fahrzeuge",
  });
  const googleSiteVerification =
    configuration.application?.googleSiteVerification || undefined;
  const title = configuration.application.title || "carbando catalog";

  return (
    <>
      <h1 className="aria-hidden">{headline}</h1>
      <Helmet>
        <title>{`${title} - ${headline}`}</title>
        {googleSiteVerification && (
          <meta
            name="google-site-verification"
            content={googleSiteVerification}
          />
        )}
        {configuration.application.inline === false && (
          <>
            <meta property="og:title" content={`${title} - ${headline}`} />
            <meta property="og:url" content={href} />
            <meta property="og:type" content="article" />
            <meta property="og:site_name" content={title} />
          </>
        )}
      </Helmet>
    </>
  );
};

export default Header;
